export default "__VITE_ASSET__qGwK54yj__"